<template>
  <!-- BEGIN FOOTER -->
  <div class="footer-wrapper" :class="{ 'footer-update-ativo': updateAvailable }">
    <div class="footer-section f-section-1">
      <p class="">
        Copyright © {{ anoAtual }}
        <a target="_blank" href="https://lancefacil.com">Lance Fácil</a>,

        <strong>
            <span class="text-success">{{ razaoSocialAtiva }} - {{ cnpjAtivo }}</span> #
            <span :class="strCss">{{ strVer }}</span>
        </strong>
      </p>

      <!-- Nova versao publicada: botao persistente logo depois do texto (nao por cima dele); some so depois do reload.
           O mesmo botao tambem aparece no cabecalho, para quem esta com a pagina rolada e nao ve o rodape. -->
      <button
        v-if="updateAvailable"
        type="button"
        class="btn btn-primary btn-sm btn-atualizar-app"
        title="Nova versão disponível. Clique para recarregar."
        @click="recarregar"
      >
        Atualizar app
      </button>
    </div>

    <div class="footer-section f-section-2">
      <p class="">
        Feito com
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-heart"
        >
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          ></path>
        </svg>
      </p>
    </div>
  </div>
  <!-- END FOOTER -->
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useAppUpdate } from '@/composables/useAppUpdate';

// Detector de deploy novo (singleton: um watch por aba)
const { updateAvailable, recarregar } = useAppUpdate();

const store = useStore();
const userDados = computed(() => store.getters.userDados);
// Multi-CNPJ: exibe a empresa ativa (filha selecionada ou titular)
const razaoSocialAtiva = computed(() => store.getters.razaoSocialAtiva);
const cnpjAtivo = computed(() => store.getters.cnpjAtivo);
const anoAtual = ref(new Date().getFullYear());
const strVer = ref('');
const strCss = ref('');

const verificaVersao = () => {
  if (userDados.value.versaobd && userDados.value.versaobduser) {
    if (userDados.value.versaobd !== userDados.value.versaobduser) {
      strVer.value = "Versão: " + userDados.value.versaobduser + " ~ " + userDados.value.versaobd;
      strCss.value = 'versao-down';
    } else {
      strVer.value = "Versão: " + userDados.value.versaobduser;
      strCss.value = 'versao-ok';
    }
  }
};

// Observa mudanças em userDados para chamar verificaVersao quando necessário
watch(userDados, verificaVersao, { immediate: true });

</script>

<style scoped>
.versao-ok {
  color: darkgreen;
}

.versao-down {
  color: red;
}

/* O botao fica na frente (depois) do texto da esquerda, no fluxo normal: nada fica por cima do texto
   (antes ele era absoluto no centro e cobria o final do texto, como a versao). Em tela estreita quebra a linha. */
.f-section-1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.f-section-1 p {
  margin-bottom: 0;
}

.btn-atualizar-app {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 3px 14px;
  white-space: nowrap;
}

/* Destaca o rodape enquanto houver versao nova pendente */
.footer-update-ativo {
  background: rgba(27, 85, 226, 0.08);
  border-radius: 6px;
}
</style>
